// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"Totalcounts__materialize-textarea___3Qkkp","modal-2463794813":"Totalcounts__modal-2463794813___1MK-L","container":"Totalcounts__container___3LNfj","counts":"Totalcounts__counts___2gVO5","centerDiv":"Totalcounts__centerDiv___1Xvwc","countsBody":"Totalcounts__countsBody___26Xor","totalNumberText":"Totalcounts__totalNumberText___-BJoC","totalNumber":"Totalcounts__totalNumber___YrdMF","underline":"Totalcounts__underline___3saV1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TotalCounts/Totalcounts.scss
// module id = 1542
// module chunks = 0